import { CustomerOrganizationDetail } from "../CustomersTable/customerDetail";
import { ExpandableDetailDialog } from "./ExpandableDetailDialog";

type CustomerDetailModalProps = {
  customerId: number | null;
  opened: boolean;
  onClose: () => void;
  onOpenInvoice?: (externalId: string) => void;
};

export function CustomerDetailModal({
  customerId,
  opened,
  onClose,
  onOpenInvoice,
}: CustomerDetailModalProps) {
  return (
    <ExpandableDetailDialog
      opened={opened && customerId != null}
      title="Customer"
      titleId="customer-detail-title"
      closeAriaLabel="Close customer"
      resetKey={customerId}
      onClose={onClose}
    >
      {customerId != null ? (
        <CustomerOrganizationDetail
          customerId={customerId}
          panelMode
          embedded
          onClosePanel={onClose}
          onOpenInvoice={onOpenInvoice}
        />
      ) : null}
    </ExpandableDetailDialog>
  );
}
